<template>
  <div class="col-md-12 price-incr">
    <div class="row">
      <div class="col-md-8 label-col">
        <label v-translation="{ code: 'label_price_increment', type: 'label' }"></label>
      </div>
      <div class="col-md-4">
        <utlz-decimal-field :incrementStep="0.01" :initialValue="quotation.priceIncrement" @valueUpdatedEvent="updatePriceIncrement($event)"></utlz-decimal-field>
      </div>
    </div>
  </div>
</template>

<script>
import DecimalField from './../../bespoke/quotations/DecimalField.vue';
export default {
  props: {
    quotation: { type: Object, required: true}
  },
  components: {
    'utlz-decimal-field': DecimalField
  },
  methods: {
    updatePriceIncrement(amount) {
      this.$emit('onUpdatePriceIncrement', { priceIncrement: amount });
    }
  }
}
</script>

<style>

</style>